/**
 * Brand label map — ensures correct casing for all brand names.
 * Shared across discover, template detail, and featured templates.
 */
export const brandLabels: Record<string, string> = {
  acme: "Acme",
  adobe: "Adobe",
  airbnb: "Airbnb",
  amazon: "Amazon",
  apple: "Apple",
  asana: "Asana",
  atlassian: "Atlassian",
  booking: "Booking.com",
  calendly: "Calendly",
  canva: "Canva",
  clickup: "ClickUp",
  coinbase: "Coinbase",
  coursera: "Coursera",
  dhl: "DHL",
  discord: "Discord",
  docusign: "DocuSign",
  doordash: "DoorDash",
  dropbox: "Dropbox",
  duolingo: "Duolingo",
  ebay: "eBay",
  etsy: "Etsy",
  eventbrite: "Eventbrite",
  fedex: "FedEx",
  figma: "Figma",
  github: "GitHub",
  google: "Google",
  grammarly: "Grammarly",
  hm: "H&M",
  hubspot: "HubSpot",
  instagram: "Instagram",
  intercom: "Intercom",
  klarna: "Klarna",
  linear: "Linear",
  linkedin: "LinkedIn",
  loom: "Loom",
  mailchimp: "Mailchimp",
  medium: "Medium",
  microsoft: "Microsoft",
  monday: "Monday.com",
  monzo: "Monzo",
  msteams: "Microsoft Teams",
  neon: "Neon",
  netflix: "Netflix",
  netlify: "Netlify",
  nike: "Nike",
  notion: "Notion",
  openai: "OpenAI",
  paypal: "PayPal",
  pinterest: "Pinterest",
  posthog: "PostHog",
  reddit: "Reddit",
  resend: "Resend",
  revolut: "Revolut",
  salesforce: "Salesforce",
  sendgrid: "SendGrid",
  sentry: "Sentry",
  shopify: "Shopify",
  slack: "Slack",
  spotify: "Spotify",
  stripe: "Stripe",
  supabase: "Supabase",
  tesla: "Tesla",
  tiktok: "TikTok",
  todoist: "Todoist",
  twilio: "Twilio",
  twitch: "Twitch",
  twitter: "X (Twitter)",
  typeform: "Typeform",
  uber: "Uber",
  ups: "UPS",
  vercel: "Vercel",
  wise: "Wise",
  youtube: "YouTube",
  zara: "Zara",
  zoom: "Zoom",
};

/**
 * Get the correctly-cased brand label, falling back to capitalized slug.
 */
export function toBrandLabel(brand: string): string {
  return brandLabels[brand] ?? brand.charAt(0).toUpperCase() + brand.slice(1);
}